// extracted by mini-css-extract-plugin
export default {"wrapper":"SubPO_wrapper__Mr85s"};